export const GET_NOTIFICATIONS_REQUEST = 'NOTIFICATIONS/GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS/GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILURE = 'NOTIFICATIONS/GET_NOTIFICATIONS_FAILURE';
export const POST_MARK_AS_READ_REQUEST = 'NOTIFICATIONS/POST_MARK_AS_READ_REQUEST';
export const POST_MARK_AS_READ_SUCCESS = 'NOTIFICATIONS/POST_MARK_AS_READ_SUCCESS';
export const POST_MARK_AS_READ_FAILURE = 'NOTIFICATIONS/GET_NOTIFICATIONS_FAILURE';
